import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useRatings } from './RatingsContext';

function KeyPerformanceAreas({ phase, myKpas = [] }) {
    const { setKpaRatings } = useRatings();
    const ratingOptions = [
        { value: 4, label: '4 - Exceptionally Achieved' },
        { value: 3, label: '3 - Fully Achieved' },
        { value: 2, label: '2 - Partially Achieved' },
        { value: 1, label: '1 - Not Achieved' },
        { value: null, label: 'Too Early to Assess' },
    ];
    const managerKpas = [
        { kpa: 'Team Leadership', weight: '30' },
        { kpa: 'Project Delivery', weight: '40' },
        { kpa: 'Resource Optimization', weight: '30' },
    ];
    const isSelfAssessment = phase === 'self-assessment';
    const isCaptureProgress = phase === 'capture-progress';
    const isReadOnly = isSelfAssessment || isCaptureProgress;
    const [kpas, setKpas] = useState(myKpas);
    const [showKpaModal, setShowKpaModal] = useState(false);
    const [showManagerKpaModal, setShowManagerKpaModal] = useState(false);
    const [newKpa, setNewKpa] = useState({ kpa: '', weight: '' });
    const [showKpiModal, setShowKpiModal] = useState(false);
    const [newKpi, setNewKpi] = useState({
        description: '',
        resources: '',
        annualTarget: '',
        measurement: '',
        progress: '',
        challenges: '',
        correctiveMeasures: '',
    });
    const [selectedKpaIndex, setSelectedKpaIndex] = useState(null);
    const [selectedKpiIndex, setSelectedKpiIndex] = useState(null);
    const [isEditingKpi, setIsEditingKpi] = useState(false);
    const [expandedKpas, setExpandedKpas] = useState(myKpas.reduce((acc, _, index) => ({ ...acc, [index]: false }), {}));

    const handleAddKpa = () => {
        console.log('handleAddKpa called with newKpa:', newKpa);
        const missingFields = [];
        if (!newKpa.kpa) missingFields.push('Organisation Objective');
        if (!newKpa.weight) missingFields.push('Weight');

        if (missingFields.length > 0) {
            alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
            console.log('Validation failed, missing required fields:', missingFields);
            return;
        }

        console.log('Required fields valid, adding Organisation Objective');
        setKpas([...kpas, { ...newKpa, selfRating: null, lineManagerRating: null, kpis: [] }]);
        setExpandedKpas((prev) => ({ ...prev, [kpas.length]: false }));
        setNewKpa({ kpa: '', weight: '' });
        setShowKpaModal(false);
        console.log('Organisation Objective added, updated kpas:', kpas);
    };

    const handleCascadeKpa = (managerKpa) => {
        console.log('handleCascadeKpa called with managerKpa:', managerKpa);
        setKpas([...kpas, { ...managerKpa, selfRating: null, lineManagerRating: null, kpis: [] }]);
        setExpandedKpas((prev) => ({ ...prev, [kpas.length]: false }));
        setShowManagerKpaModal(false);
        console.log('Manager KPA cascaded, updated kpas:', kpas);
    };

    const handleRatingChange = (index, type, value) => {
        console.log(`handleRatingChange called for index: ${index}, type: ${type}, value: ${value}`);
        const updatedKpas = [...kpas];
        updatedKpas[index][type] = value ? parseFloat(value) : null;
        setKpas(updatedKpas);
    };

    const handleAddKpi = () => {
        console.log('handleAddKpi called with newKpi:', newKpi);
        console.log('selectedKpaIndex:', selectedKpaIndex);
        const missingFields = [];
        if (!newKpi.description) missingFields.push('Goal Description');
        if (!newKpi.resources) missingFields.push('Success');
        if (!newKpi.annualTarget) missingFields.push('Timeframe');

        if (missingFields.length > 0) {
            alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
            console.log('Validation failed, missing required fields:', missingFields);
            return;
        }

        console.log('Required fields valid, adding KPI');
        const updatedKpas = [...kpas];
        updatedKpas[selectedKpaIndex].kpis.push({ ...newKpi });
        setKpas(updatedKpas);
        setNewKpi({
            description: '',
            resources: '',
            annualTarget: '',
            measurement: '',
            progress: '',
            challenges: '',
            correctiveMeasures: '',
        });
        setShowKpiModal(false);
        setSelectedKpaIndex(null);
        console.log('KPI added, updated kpas:', updatedKpas);
    };

    const handleEditKpi = (kpaIndex, kpiIndex) => {
        console.log('handleEditKpi called for Organisation Objective:', kpaIndex, 'KPI:', kpiIndex);
        setSelectedKpaIndex(kpaIndex);
        setSelectedKpiIndex(kpiIndex);
        setNewKpi({ ...kpas[kpaIndex].kpis[kpiIndex] });
        setIsEditingKpi(true);
        setShowKpiModal(true);
    };

    const handleSaveEditKpi = () => {
        console.log('handleSaveEditKpi called with newKpi:', newKpi);
        console.log('selectedKpaIndex:', selectedKpaIndex, 'selectedKpiIndex:', selectedKpiIndex);
        const missingFields = [];
        if (!newKpi.description) missingFields.push('Goal Description');
        if (!newKpi.resources) missingFields.push('Success');
        if (!newKpi.annualTarget) missingFields.push('Timeframe');

        if (missingFields.length > 0 && !isCaptureProgress) {
            alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
            console.log('Validation failed, missing required fields:', missingFields);
            return;
        }

        console.log('Required fields valid, updating KPI');
        const updatedKpas = [...kpas];
        updatedKpas[selectedKpaIndex].kpis[selectedKpiIndex] = { ...newKpi };
        setKpas(updatedKpas);
        setNewKpi({
            description: '',
            resources: '',
            annualTarget: '',
            measurement: '',
            progress: '',
            challenges: '',
            correctiveMeasures: '',
        });
        setShowKpiModal(false);
        setSelectedKpaIndex(null);
        setSelectedKpiIndex(null);
        setIsEditingKpi(false);
        console.log('KPI updated, updated kpas:', updatedKpas);
    };

    const handleShowKpis = (index) => {
        console.log('handleShowKpis called for index:', index);
        setExpandedKpas((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const handleAddKpiModal = (index) => {
        console.log('handleAddKpiModal called for index:', index);
        setSelectedKpaIndex(index);
        setNewKpi({
            description: '',
            resources: '',
            annualTarget: '',
            measurement: '',
            progress: '',
            challenges: '',
            correctiveMeasures: '',
        });
        setIsEditingKpi(false);
        setShowKpiModal(true);
    };

    const handleProgressChange = (kpaIndex, kpiIndex, value) => {
        console.log('handleProgressChange called for kpaIndex:', kpaIndex, 'kpiIndex:', kpiIndex, 'value:', value);
        const updatedKpas = [...kpas];
        updatedKpas[kpaIndex].kpis[kpiIndex].progress = value;
        setKpas(updatedKpas);
    };

    const handleChallengesChange = (kpaIndex, kpiIndex, value) => {
        console.log('handleChallengesChange called for kpaIndex:', kpaIndex, 'kpiIndex:', kpiIndex, 'value:', value);
        const updatedKpas = [...kpas];
        updatedKpas[kpaIndex].kpis[kpiIndex].challenges = value;
        setKpas(updatedKpas);
    };

    const handleCorrectiveMeasuresChange = (kpaIndex, kpiIndex, value) => {
        console.log('handleCorrectiveMeasuresChange called for kpaIndex:', kpaIndex, 'kpiIndex:', kpiIndex, 'value:', value);
        const updatedKpas = [...kpas];
        updatedKpas[kpaIndex].kpis[kpiIndex].correctiveMeasures = value;
        setKpas(updatedKpas);
    };

    const calculateRatedPercentage = (type) => {
        if (kpas.length === 0) return { rating: null, percentage: null };
        const ratedKpas = kpas.filter((kpa) => kpa[type] !== null).length;
        const percentage = (ratedKpas / kpas.length) * 100;
        const averageRating =
            ratedKpas > 0
                ? Math.round(
                    kpas
                        .filter((kpa) => kpa[type] !== null)
                        .reduce((sum, kpa) => sum + kpa[type], 0) / ratedKpas
                )
                : null;
        return {
            rating: averageRating,
            percentage: percentage ? parseFloat(((averageRating / 4) * 100).toFixed(0)) : null,
        };
    };

    useEffect(() => {
        const selfRatingData = calculateRatedPercentage('selfRating');
        const lineManagerRatingData = calculateRatedPercentage('lineManagerRating');
        setKpaRatings({ selfRatingData, lineManagerRatingData });
    }, [kpas, setKpaRatings]);

    const weightTotal = kpas.reduce((sum, kpa) => sum + (kpa && kpa.weight ? parseFloat(kpa.weight) : 0), 0);
    const selfRatingData = calculateRatedPercentage('selfRating');
    const lineManagerRatingData = calculateRatedPercentage('lineManagerRating');

    const renderStars = (rating) => {
        if (rating === null) return 'Too Early to Assess';
        const maxRating = 4;
        return [...Array(maxRating)].map((_, i) => (
            <i key={i} className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'} text-warning me-1`} />
        ));
    };

    return (
        <div className="container mt-4">
            <div className="d-flex align-items-center mb-3 bg-tertiary p-2 text-light rounded">
                <h4 className="mb-0">Section A: Key Performance Areas (KPAs)</h4>
                <div className="ms-auto d-flex gap-2">
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => setShowKpaModal(true)}
                        disabled={isReadOnly}
                    >
                        Add New Organisation Objective
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => setShowManagerKpaModal(true)}
                        // disabled={isReadOnly}
                    >
                        Manager Objective
                    </button>
                </div>
            </div>
            <div className="row g-3">
                <div className="col-lg-4 col-md-6">
                    <div className="card h-100">
                        <div className="card-body">
                            <label htmlFor="kpaScore" className="form-label mb-2">Organisation Objective Score (%)</label>
                            <input
                                type="number"
                                className="form-control mb-3"
                                id="kpaScore"
                                value="80"
                                readOnly
                                disabled
                            />
                            <label htmlFor="weightTotal" className="form-label mb-2">Weight Total</label>
                            <input
                                type="number"
                                className="form-control"
                                id="weightTotal"
                                value={weightTotal || 0}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="card h-100">
                        <div className="card-body">
                            <h5 className="card-title">Self Rating</h5>
                            <div className="d-flex align-items-center mb-2">
                                <div className="me-3">{renderStars(selfRatingData.rating)}</div>
                                <span>{selfRatingData.rating !== null ? `${selfRatingData.rating}/4` : 'Too Early to Assess'}</span>
                            </div>
                            <div className="progress" style={{ height: '20px' }}>
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: selfRatingData.percentage ? `${selfRatingData.percentage}%` : '0%' }}
                                    aria-valuenow={selfRatingData.percentage || 0}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {selfRatingData.percentage !== null ? `${selfRatingData.percentage}%` : 'Not Rated'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="card h-100">
                        <div className="card-body">
                            <h5 className="card-title">Line Manager Rating</h5>
                            <div className="d-flex align-items-center mb-2">
                                <div className="me-3">{renderStars(lineManagerRatingData.rating)}</div>
                                <span>{lineManagerRatingData.rating !== null ? `${lineManagerRatingData.rating}/4` : 'Too Early to Assess'}</span>
                            </div>
                            <div className="progress" style={{ height: '20px' }}>
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: lineManagerRatingData.percentage ? `${lineManagerRatingData.percentage}%` : '0%' }}
                                    aria-valuenow={lineManagerRatingData.percentage || 0}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {lineManagerRatingData.percentage !== null ? `${lineManagerRatingData.percentage}%` : 'Not Rated'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <table className="table table-bordered">
                    <thead className="bg-tertiary text-light rounded">
                    <tr>
                        <th width="45%">Organisation Objective</th>
                        <th>Weight</th>
                        <th>Self Rating</th>
                        <th>Line Manager Rating</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {kpas.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="text-center">No Organisation Objectives added</td>
                        </tr>
                    ) : (
                        kpas.map((kpa, index) => (
                            <React.Fragment key={`kpa-${index}`}>
                                <tr>
                                    <td>{kpa.kpa}</td>
                                    <td>{kpa.weight}</td>
                                    <td>
                                        <select
                                            className="form-select"
                                            value={kpa.selfRating || ''}
                                            onChange={(e) => handleRatingChange(index, 'selfRating', e.target.value)}
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select Rating</option>
                                            {ratingOptions.map((option) => (
                                                <option key={option.value || 'null'} value={option.value || ''}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            className="form-select"
                                            value={kpa.lineManagerRating || ''}
                                            onChange={(e) => handleRatingChange(index, 'lineManagerRating', e.target.value)}
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select Rating</option>
                                            {ratingOptions.map((option) => (
                                                <option key={option.value || 'null'} value={option.value || ''}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <div className="d-flex gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={() => handleAddKpiModal(index)}
                                                disabled={isReadOnly}
                                            >
                                                Add Goal/Objective
                                            </button>
                                            {kpa.kpis && kpa.kpis.length > 0 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary btn-sm"
                                                    onClick={() => handleShowKpis(index)}
                                                >
                                                    {expandedKpas[index] ? 'Hide KPIs' : 'Show KPIs'}
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                {expandedKpas[index] &&
                                    kpa.kpis &&
                                    kpa.kpis.map((kpi, kpiIndex) => (
                                        <tr key={`kpi-${index}-${kpiIndex}`} className="table-secondary">
                                            <td colSpan="5">
                                                <div className="p-2">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <strong>Performance Goal/Objective {kpiIndex + 1}</strong>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm"
                                                            onClick={() => handleEditKpi(index, kpiIndex)}
                                                            disabled={isReadOnly}
                                                        >
                                                            Edit Goal/Objective
                                                        </button>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Goal Description</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    value={kpi.description || ''}
                                                                    readOnly
                                                                    disabled
                                                                    rows={4}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Success</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    value={kpi.resources || ''}
                                                                    readOnly
                                                                    disabled
                                                                    rows={4}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Timeframe</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    value={kpi.annualTarget || ''}
                                                                    readOnly
                                                                    disabled
                                                                    rows={4}
                                                                />
                                                            </div>
                                                            {kpi.measurement && (
                                                                <div className="mb-3">
                                                                    <label className="form-label">Alignment</label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        value={kpi.measurement}
                                                                        readOnly
                                                                        disabled
                                                                        rows={4}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label">Comments</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    value={kpi.challenges || ''}
                                                                    onChange={(e) => isCaptureProgress && handleChallengesChange(index, kpiIndex, e.target.value)}
                                                                    readOnly={!isCaptureProgress}
                                                                    disabled={!isCaptureProgress}
                                                                    rows={4}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Corrective Measures</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    value={kpi.correctiveMeasures || ''}
                                                                    onChange={(e) => isCaptureProgress && handleCorrectiveMeasuresChange(index, kpiIndex, e.target.value)}
                                                                    readOnly={!isCaptureProgress}
                                                                    disabled={!isCaptureProgress}
                                                                    rows={4}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Progress</label>
                                                                {isReadOnly ? (
                                                                    <div className="input-group">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={kpi.progress || ''}
                                                                            onChange={(e) => handleProgressChange(index, kpiIndex, e.target.value)}
                                                                            min="0"
                                                                            max="100"
                                                                        />
                                                                        <span className="input-group-text">%</span>
                                                                    </div>
                                                                ) : (
                                                                    <div className="progress" style={{ height: '20px' }}>
                                                                        <div
                                                                            className="progress-bar"
                                                                            role="progressbar"
                                                                            style={{ width: `${kpi.progress || 0}%` }}
                                                                            aria-valuenow={kpi.progress || 0}
                                                                            aria-valuemin="0"
                                                                            aria-valuemax="100"
                                                                        >
                                                                            {kpi.progress || 0}%
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </React.Fragment>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
            <div className={`modal fade ${showKpaModal ? 'show d-block' : ''}`} style={{ backgroundColor: showKpaModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Organisation Objective</h5>
                            <button type="button" className="btn-close" onClick={() => setShowKpaModal(false)} />
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="kpaText" className="form-label">Organisation Objective</label>
                                <textarea
                                    className="form-control"
                                    id="kpaText"
                                    value={newKpa.kpa}
                                    onChange={(e) => setNewKpa({ ...newKpa, kpa: e.target.value })}
                                    rows={4}
                                    readOnly={isReadOnly}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="kpaWeight" className="form-label">Weight</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="kpaWeight"
                                    value={newKpa.weight}
                                    onChange={(e) => setNewKpa({ ...newKpa, weight: e.target.value })}
                                    min="0"
                                    readOnly={isReadOnly}
                                    disabled={isReadOnly}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setShowKpaModal(false)}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAddKpa}
                                disabled={isReadOnly}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal fade ${showManagerKpaModal ? 'show d-block' : ''}`} style={{ backgroundColor: showManagerKpaModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Manager Objectives</h5>
                            <button type="button" className="btn-close" onClick={() => setShowManagerKpaModal(false)} />
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered">
                                <thead className="bg-tertiary text-light rounded">
                                <tr>
                                    <th>Objective</th>
                                    <th>Weight</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {managerKpas.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="text-center">No Manager Objectives available</td>
                                    </tr>
                                ) : (
                                    managerKpas.map((managerKpa, index) => (
                                        <tr key={`manager-kpa-${index}`}>
                                            <td>{managerKpa.kpa}</td>
                                            <td>{managerKpa.weight}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => handleCascadeKpa(managerKpa)}
                                                >
                                                    Cascade
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setShowManagerKpaModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default KeyPerformanceAreas;